import { watch } from 'vue'

const ID_CODE_LENGTH = 11

/**
 * RED-286: check an isikukood against App\Rules\EstonianIdCode through Laravel
 * Precognition as soon as the 11th digit is typed, instead of only on submit.
 * A mistyped isikukood is the one error here that stays silent until the person
 * cannot log in with their eID months later, so it is caught while the admin is
 * still looking at the field.
 *
 * Only the format, checksum and birth date are checked live. "Already taken"
 * stays in IdCodeGuard on submit: one owner for uniqueness, and the field can't
 * be used as a live "is this person a REdata user?" probe.
 *
 * @param {object} form a precognitive Inertia form, i.e. useForm(method, url, data)
 * @param {string} field
 */
export function useIdCodeValidation(form, field = 'id_code') {
  form.setValidationTimeout(300)

  watch(
    () => form[field],
    value => {
      if (String(value ?? '').replace(/\s/g, '').length === ID_CODE_LENGTH) {
        form.validate(field)
      }
    },
  )
}
